import Coverage from '@/modules/common/common/models/MID/Coverage'
import DefaultPetBreeds from '../constants/DefaultPetBreeds'

export function needsCivilLiabilityQuestion(coverages: Coverage[]) {
  return !!coverages.find((c) => c.coverageCode === 'RC01')
}

export function needsCivilLiabilityForm(coverages: Coverage[]) {
  // these are the included coverages, otherwise it is additional and you need the form
  const includedCoverages = ['AV01', 'AV02', 'AV03']
  return !!coverages.find((c) => !includedCoverages.includes(c.coverageCode))
}

export function isPureBreed(breedCode: number): boolean {
  return ![DefaultPetBreeds.Dog, DefaultPetBreeds.Cat].includes(breedCode)
}

export function needsAccidentCoverageQuestion(coverages: Coverage[]) {
  return !!coverages.find((c) => c.coverageCode === 'AV04')
}
